import { FC } from 'react';
import { Loading } from '@/components/partials/loading/Loading';

export const Handoff: FC = () => {
	return <Loading />;
};
